var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"font-mullerBlack text-4xl 1024:text-6xl mb-3",class:_vm.getTextColor()},[_vm._t("default",function(){return [_c('span',[_vm._v("ПОЗДРАВЛЯЕМ!")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }